import { useState, useCallback } from 'react';
import type { Spot, UpdateSpotRequest } from '@ridehub/shared';
import { apiClient, ApiError } from '../../lib/api-client.js';

export function useSpotEdit() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const update = useCallback(
    async (spotId: string, data: UpdateSpotRequest): Promise<Spot | null> => {
      setLoading(true);
      setError(null);
      try {
        const spot = await apiClient.put<Spot>(`/spots/${spotId}`, data, { requireAuth: true });
        return spot;
      } catch (err) {
        if (err instanceof ApiError) {
          setError(err.message);
        } else {
          setError('スポットの更新に失敗しました');
        }
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { update, loading, error };
}
